import React from 'react'
import styled, { css } from 'styled-components/macro'

import SmartphoneGym from '../../assets/icons/SmartphoneGym'
import ComeFunzionaImg from '../../assets/images/ComeFunziona.jpg'
import { Title } from '../atoms/Typography'

export default function ComeFunzionaText({ marginTop }) {
  return (
    <Content margin={marginTop}>
      <Figure>
        <img src={ComeFunzionaImg} alt="come funziona" />
      </Figure>

      <TextSection>
        <ListHeader>
          <Title as="h2" size="23px">
            Come funziona <span>smart gym</span>
          </Title>
          <p>
            Leggi i seguenti 4 punti per capire in pochi passi come funziona
            smart gym.
          </p>
          <SmartphoneGym />
        </ListHeader>

        <List>
          <li>
            <Title as="h2">
              <span>1.</span>Registrati al sito
            </Title>
            <p>
              Per poter acquistare e prenotare una sessione in palestra, c'è
              bisogno di registrarsi.
              <br />
              Lo si può fare sia da questo sito che dall'app mobile presente
              sugli store Android® ed Apple®.
            </p>
          </li>
          <li>
            <Title as="h2">
              <span>2.</span>Scarica l'app dagli store
            </Title>
            <p>Dall'app sarà possibile effettuare alcune operazioni.</p>
          </li>
          <li>
            <Title as="h2">
              <span>3.</span>Prenota una sessione
            </Title>
            <p>
              Scegli la sede, il giorno e, se avrai acquistato delle entrate,
              potrai prenotare una sessione sia dal sito che dall'app mobile.
            </p>
          </li>
          <li>
            <Title as="h2">
              <span>4.</span>Inserisci il codice nella serratura
            </Title>
            <p>
              Il codice per sbloccare la serratura della porta d'accesso alla
              palestra, sarà automaticamente visibile solo sulla tua app mobile
              una volta che sarà il momento per te di entrare. Non dimenticarti
              quindi di scaricare l'app.
            </p>
          </li>
        </List>
      </TextSection>
    </Content>
  )
}

const Content = styled.article`
  display: flex;
  flex-direction: column-reverse;

  @media screen and (min-width: 1024px) {
    flex-direction: row;
    flex-wrap: wrap;

    ${(props) =>
      props.margin &&
      css`
        margin-top: 50px;
      `}
  }
`

const Figure = styled.figure`
  overflow: hidden;

  img {
    width: 100%;
    transform: translate(-10px, -10px);
  }
  @media screen and (min-width: 1024px) {
    width: 50%;
    overflow: hidden;
    margin-top: -40px;
    margin-left: -50px;
  }
`
const TextSection = styled.section`
  @media screen and (min-width: 1024px) {
    flex: 1;
    margin-left: 60px;
    max-width: 480px;
  }
`

const ListHeader = styled.header`
  position: relative;
  font-family: 'Montserrat', Arial, Helvetica, sans-serif;
  font-size: 18px;
  padding-right: 100px;

  h2 span {
    display: block;
    font-family: 'AmpleAlt', Arial, Helvetica, sans-serif;
    font-size: 48px;
    font-weight: 400;
    line-height: 1;
    margin-top: 4px;
    margin-bottom: 16px;
  }
  svg {
    position: absolute;
    right: -20px;
    top: 10px;
    display: block;
    width: 110px;
    height: auto;
  }
  @media screen and (max-width: 1023px) {
    padding-right: 80px;
  }
`

const List = styled.ol`
  padding-left: 0;
  list-style: none;
  margin-top: 40px;

  > li {
    margin: 24px 0;

    > h2 {
      font-weight: 800;
      color: #212121;

      > span {
        color: #fe7e36;
        margin-right: 5px;
      }
    }

    > p {
      margin: 10px 0;
    }
  }
  @media screen and (max-width: 1023px) {
    > li {
      > h2 {
        > span {
          display: block;
        }
      }
    }
  }
`
